import { Clock, User } from 'lucide-react';
import { formatRelativeTimestamp } from './format-relative-timestamp';

/**
 * One History / audit row: User avatar, title, optional type chip,
 * description, optional detail, Clock + relative time + actor.
 */
export function HistoryAuditEventRow({
  title,
  typeLabel,
  description,
  detail,
  timestamp,
  actorName,
}: {
  title: string;
  typeLabel?: string | null;
  description?: string | null;
  detail?: string | null;
  timestamp: string;
  actorName?: string | null;
}) {
  return (
    <div className="px-3 py-3 hover:bg-muted">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-muted">
          <User className="h-3.5 w-3.5 text-muted-foreground" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="mb-0.5 flex items-center gap-2">
            <h4 className="text-sm font-medium text-foreground">{title}</h4>
            {typeLabel ? (
              <span className="rounded-full bg-muted px-1.5 py-0.5 text-xs text-muted-foreground">
                {typeLabel}
              </span>
            ) : null}
          </div>
          {description ? (
            <p className="mb-1 text-xs text-muted-foreground">{description}</p>
          ) : null}
          {detail ? (
            <p className="mb-1 whitespace-pre-wrap text-xs text-muted-foreground">{detail}</p>
          ) : null}
          <div className="flex items-center gap-2 text-xs text-muted-foreground/70">
            <Clock className="h-3 w-3" />
            <span>{formatRelativeTimestamp(timestamp)}</span>
            <span>•</span>
            <span className="capitalize">{actorName || 'Unknown'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
